/* @flow */
import * as React from 'react';
import { observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeForm from 'forms/_.extend';

import SiteAddress from 'components/SiteAddress/SiteAddress';
import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerLocation from 'views/ActionDrawer/components/ActionDrawerLocation/ActionDrawerLocation';
import { ComponentWithInjectedProps } from 'utils/injectedProps';

import styles from '../../../../ActionDrawer.module.scss';

type InjectedProps = TranslatorProps;

type AssignOrChangeUserLocationFormProps = {
  user: Object,
  account: Object,
  form: TypeForm,
};

@translate()
@observer
export default class AssignOrChangeUserLocationForm extends ComponentWithInjectedProps<
  AssignOrChangeUserLocationForm,
  {},
  InjectedProps
> {
  render() {
    const { t, user, account, form } = this.props;
    const hasLocation = user.location;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:activities.assigned_location')}
          >
            <div className={styles['info-block']}>
              {user.location ? (
                <SiteAddress {...user.location.site.address} siteName={this.siteName} />
              ) : (
                <ul>
                  <li>{t('general:search_results.no_location_found')}</li>
                </ul>
              )}
            </div>
          </ActionDrawerBlock>
          <ActionDrawerBlock gutters={true} heading={form.$('changeLocation').label}>
            <ActionDrawerLocation
              field={form.$('changeLocation.location')}
              accountId={account.id}
            />
          </ActionDrawerBlock>
        </div>
        <ActionDrawerFormButtons
          form={form}
          submitTxt={
            hasLocation
              ? t('general:actions.change_location')
              : t('general:actions.assign_location')
          }
        />
      </React.Fragment>
    );
  }
}
